import { render } from "./CreateNewUrl.vue?vue&type=template&id=22a69392&ts=true"
import script from "./CreateNewUrl.vue?vue&type=script&lang=ts"
export * from "./CreateNewUrl.vue?vue&type=script&lang=ts"

import "./CreateNewUrl.vue?vue&type=style&index=0&id=22a69392&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__